<p-panel class="p-2">
  <h2> {{ 'animalDetails.timeline.headline' | transloco }}</h2>
  <p-timeline
    [value]="events"
    align="alternate"
    class="customized-timeline"
  >
    <ng-template #marker let-event>
      <div class="flex items-center justify-center w-12 h-12 bg-primary rounded-full" [ngStyle]="{'background-color': event.backgroundColor}">
        <i [ngClass]="event.icon ? event.icon : 'pi pi-pen-to-square'"></i>
      </div>
    </ng-template>
    <ng-template #content let-event>
      <p-panel [header]="event.status + ' ' + event.date">
        @if (event.image) {
          <img
            [src]="event.image.base64"
            [alt]="event.name"
            width="200"
            class="shadow-2"
          />
        }
        @if (event.imageId) {
          <div class="w-[10rem] h-[10rem] relative">
            <app-animal-image-container
              [animal]="animal"
              [id]="event.imageId"
              [variant]="'app-preview'"
            />
          </div>
        }
        <p [innerHTML]="event.data"></p>
      </p-panel>
    </ng-template>
  </p-timeline>
  <p-scrollTop class="custom-scrolltop" [threshold]="500" icon="pi pi-arrow-up"></p-scrollTop>
</p-panel>
